import React from 'react';

class DownArrowIcon extends React.Component {

    render() {
        return (
            <svg className="d-none d-sm-block" width="10" height="16" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.09375 0.78125C0.03125 0.71875 0 0.625 0 0.5C0 0.354167 0.0520833 0.239583 0.15625 0.15625C0.260417 0.0520833 0.385417 0 0.53125 0H9.46875C9.61458 0 9.73958 0.0520833 9.84375 0.15625C9.94792 0.239583 10 0.354167 10 0.5C10 0.604167 9.96875 0.6875 9.90625 0.75L9.84375 0.84375L5.59375 5.71875C5.40625 5.90625 5.20833 6 5 6C4.79167 6 4.59375 5.90625 4.40625 5.71875L0.15625 0.84375L0.09375 0.78125Z" fill="#3D77BC"></path>
            </svg>
        )
    }

}

export default DownArrowIcon;
